import(/* webpackMode: "eager", webpackExports: ["CompanyHero"] */ "/app/components/frontend/mlm-companies/company-hero.tsx");
